"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateComponentsQuery = exports.getCsrfTokenGqlQuery = exports.getThankYouPageGqlQuery = exports.getDetailPageGqlQuery = void 0;
const apollo_boost_1 = require("apollo-boost");
exports.getDetailPageGqlQuery = (0, apollo_boost_1.gql) `
  query getDetailPage(
    $asin: String
    $customerId: String
    $deviceType: DeviceType!
    $platformType: PlatformType
    $marketplaceId: String!
    $locale: String!
    $pageType: PageType!
    $customHeaders: JSON
  ) {
    csrf {
      csrfToken
    }
    page(
      asin: $asin
      customerId: $customerId
      deviceType: $deviceType
      platformType: $platformType
      marketplaceId: $marketplaceId
      locale: $locale
      pageType: $pageType
      customHeaders: $customHeaders
    ) {
      componentDefinitionString
      tenant
      countryCode
      shoppingPortalConfig {
        navStoreName
        navNodeId
      }
    }
  }
`;
exports.getThankYouPageGqlQuery = (0, apollo_boost_1.gql) `
  query getThankYouPage(
    $asin: String
    $orderId: String
    $deviceType: DeviceType!
    $platformType: PlatformType
    $marketplaceId: String!
    $locale: String!
    $pageType: PageType!
    $customerId: String
    $customHeaders: JSON
  ) {
    page(
      asin: $asin
      orderId: $orderId
      deviceType: $deviceType
      platformType: $platformType
      marketplaceId: $marketplaceId
      locale: $locale
      pageType: $pageType
      customerId: $customerId
      customHeaders: $customHeaders
    ) {
      tenant
      countryCode
      componentDefinitionString
      shoppingPortalConfig {
        navStoreName
        navNodeId
      }
    }
  }
`;
exports.getCsrfTokenGqlQuery = (0, apollo_boost_1.gql) `
  query getCsrfToken {
    csrf {
      csrfToken
    }
  }
`;
exports.hydrateComponentsQuery = (0, apollo_boost_1.gql) `
  query hydrateComponents(
    $asin: String
    $deviceType: DeviceType!
    $platformType: PlatformType
    $marketplaceId: String!
    $locale: String!
    $pageType: PageType!
    $components: [ComponentInput]
    $customHeaders: JSON
  ) {
    hydrateComponents(
      asin: $asin
      deviceType: $deviceType
      platformType: $platformType
      marketplaceId: $marketplaceId
      locale: $locale
      pageType: $pageType
      components: $components
      customHeaders: $customHeaders
    ) {
      id
      state
    }
  }
`;
